/* ==========================================================================
   GYM STUDIO — usage tracking
   ==========================================================================
   Listens for the `ctx:gym-studio:track` events ctx-gym-studio-ui.js fires on
   every meaningful action (add, remove, guard rail hit, quiz complete, add to
   cart) and logs one row per session to Airtable via an n8n webhook, upserted
   on Session ID so repeated sends just update the same row.

   Owns everything ctx-gym-studio-ui.js should not have to know about:
   the session id, how long they have been on the page, what device this is,
   and how/when to actually send. That file only ever describes what
   happened; this file decides when that is worth mailing home.

   Sends:
     - right after a successful Add to Cart (the highest-value signal — do
       not wait for them to leave the tab to record it)
     - whenever the tab is hidden or the page is being left (visibilitychange
       / pagehide), via sendBeacon so it survives the page going away

   Built 12 Aug 2026. Webhook: n8n workflow "Log Gym Builder Session".
   ========================================================================== */
(function () {
  'use strict';

  var ENDPOINT = 'https://buildagym.app.n8n.cloud/webhook/gym-builder-session';
  var SID_KEY = 'ctxGymSession.id';
  var START_KEY = 'ctxGymSession.startedAt';

  var sessionId;
  try { sessionId = sessionStorage.getItem(SID_KEY); } catch (e) {}
  if (!sessionId) {
    sessionId = 's-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    try { sessionStorage.setItem(SID_KEY, sessionId); } catch (e) {}
  }

  var startedAt;
  try { startedAt = sessionStorage.getItem(START_KEY); } catch (e) {}
  if (!startedAt) {
    startedAt = new Date().toISOString();
    try { sessionStorage.setItem(START_KEY, startedAt); } catch (e) {}
  }
  var startedAtMs = new Date(startedAt).getTime();

  var device = window.matchMedia && window.matchMedia('(max-width: 799px)').matches ? 'Mobile' : 'Desktop';

  var latest = null;

  function send() {
    if (!latest) return;
    var payload = {
      session_id: sessionId,
      started_at: startedAt,
      duration_seconds: Math.max(0, Math.round((Date.now() - startedAtMs) / 1000)),
      device: device,
      entry_point: latest.entry_point,
      room_type: latest.room_type,
      room_w: latest.room_w,
      room_d: latest.room_d,
      budget: latest.budget,
      quiz_completed: latest.quiz_completed,
      machines_added: latest.machines_added,
      machines_removed: latest.machines_removed,
      final_count: latest.final_count,
      final_list: latest.final_list,
      guard_count: latest.guard_count,
      reached_cart: latest.reached_cart,
      cart_value: latest.cart_value,
      last_action: latest.last_action
    };

    /* Not sendBeacon: it fixes its request's credentials mode to 'include',
       and n8n's webhook does not answer the resulting preflight with
       Access-Control-Allow-Credentials, so the send silently fails. A plain
       fetch sends no credentials cross-origin, which the preflight allows —
       and `keepalive` lets it survive the page going away same as a beacon
       would. */
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors'
      });
    } catch (e) {}
  }

  document.addEventListener('ctx:gym-studio:track', function (e) {
    latest = e.detail;
    if (e.detail.type === 'add-to-cart') send();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) send();
  });
  window.addEventListener('pagehide', send);
})();
